module.exports = __webpack_public_path__ + "images/fa-fw-resume.webp";